module.exports = __webpack_public_path__ + "23124c707ada27ffc7ce0af1e92a69bf.svg";